import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum EventServiceType {
	refreshNav,
}

export interface EventServiceMessage {
	type: EventServiceType;
	data: any;
}

@Injectable({
	providedIn: 'root',
})
export class EventService {
	private readonly eventSubject: Subject<EventServiceMessage> =
		new Subject<EventServiceMessage>();

	constructor() {}

	public events(): Observable<EventServiceMessage> {
		return this.eventSubject.asObservable();
	}

	public emitEvent(type: EventServiceType, data?: any): void {
		this.eventSubject.next({ type, data });
	}
}
